import script from "./LoginAppLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAppLoader.vue?vue&type=script&setup=true&lang=js"

import "./LoginAppLoader.vue?vue&type=style&index=0&id=28765250&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28765250"]])

export default __exports__